import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import { ColorProvider } from './contexts/ColorContext';
import './App.css';

function App() {
  return (
    <ColorProvider>
      <div className="App">
        <Header />
        <main>
          <Hero />
          <Services />
          <AboutUs />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </ColorProvider>
  );
}

export default App;
